import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/PinInput/OtpInput.js",
  _this = this;
import React, { useEffect, useState, useRef } from 'react';
var OtpInput = function OtpInput(_ref) {
  var numInputs = _ref.numInputs,
    onChange = _ref.onChange,
    containerStyle = _ref.containerStyle,
    inputStyle = _ref.inputStyle,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'number' : _ref$inputType,
    _ref$shouldAutoFocus = _ref.shouldAutoFocus,
    shouldAutoFocus = _ref$shouldAutoFocus === void 0 ? true : _ref$shouldAutoFocus,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var _useState = useState(value ? value.toString().split('') : Array(numInputs).fill('')),
    _useState2 = _slicedToArray(_useState, 2),
    otp = _useState2[0],
    setOtp = _useState2[1];
  var inputRefs = Array(numInputs).fill(0).map(function () {
    return useRef(null);
  });
  useEffect(function () {
    if (shouldAutoFocus && inputRefs) {
      inputRefs[0].current.focus();
    }
  }, [shouldAutoFocus, inputRefs.current]);
  useEffect(function () {
    // Reset the otp values
    if (!value) {
      setOtp(Array(numInputs).fill(''));
    }
  }, [value]);
  var isInputNum = inputType === 'number' || inputType === 'tel';
  var isInputValueValid = function isInputValueValid(value) {
    var isTypeValid = isInputNum ? !isNaN(Number(value)) : typeof value === 'string';
    return isTypeValid && value.trim().length === 1;
  };
  var handleChange = function handleChange(e, index) {
    var value = e.target.value;
    if (isInputValueValid(value)) {
      var newOtp = _toConsumableArray(otp);
      newOtp[index] = value;
      setOtp(newOtp);
      onChange(newOtp.join(''));
      if (index + 1 < numInputs && newOtp[index] !== '') {
        inputRefs[index + 1].current.removeAttribute('disabled');
        inputRefs[index + 1].current.focus();
      }
    }
  };
  var handleKeyDown = function handleKeyDown(e, index) {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      return;
    } // Move to the previous input on pressing backspace

    if (e.key === 'Backspace') {
      e.preventDefault();
      var newOtp = _toConsumableArray(otp);
      newOtp[index] = '';
      setOtp(newOtp);
      if (inputRefs[index - 1]) {
        inputRefs[index - 1].current.removeAttribute('disabled');
        inputRefs[index - 1].current.focus();
      }
    } else if (e.key === 'ArrowRight' && index < numInputs - 1 && otp[index] !== '') {
      inputRefs[index + 1].current.removeAttribute('disabled');
      inputRefs[index + 1].current.focus();
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };
  var handlePaste = function handlePaste(e, index) {
    e.preventDefault();
    var pastedData = e.clipboardData.getData('text/plain').slice(0, numInputs - index);
    var newOtp = _toConsumableArray(otp);
    for (var i = index, j = 0; j < pastedData.length; i++, j++) {
      newOtp[i] = pastedData[j];
      inputRefs[i].current.removeAttribute('disabled');
    }
    setOtp(newOtp);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: containerStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 5
    }
  }, otp.map(function (value, index) {
    return /*#__PURE__*/React.createElement("input", {
      className: inputStyle,
      key: index,
      ref: inputRefs[index],
      maxLength: "1",
      value: value,
      onChange: function onChange(e) {
        return handleChange(e, index);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, index);
      },
      disabled: index !== 0 && otp[index - 1] === '',
      onPaste: function onPaste(e) {
        return handlePaste(e, index);
      },
      type: inputType,
      "aria-label": "Please enter OTP character ".concat(index + 1),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 9
      }
    });
  }));
};
OtpInput.defaultProps = {
  containerStyle: '',
  inputStyle: '',
  shouldAutoFocus: true,
  value: ''
};
export default OtpInput;